/** @module Classes */ /** typedoc */
import { InvoicePreviewMultiProducts } from './InvoicePreviewMultiProducts';
import { InvoicePreview } from './InvoicePreview';

/**
 * This is the base for Landr Product purchases, all other Prepare Purchase should extend it.
 */
export abstract class AbstractPreparePurchase {
    public invoicePreview: InvoicePreview | InvoicePreviewMultiProducts = null;
    public token: string = null;
}
